// Copyright (c) 2026 Dyna Robotics, Inc. All rights reserved.
// Dyna Robotics Proprietary and Confidential.
// Unauthorized copying, use, or distribution is prohibited.
// SPDX-License-Identifier: LicenseRef-Dyna-Internal

/**
 * A page only some roles may use (§12.4). Reached anyway — a bookmark, a pasted link —
 * it says so, instead of a form whose every submit would be refused.
 */

import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { type Permissions, usePermissions } from "@/hooks/usePermissions";

export function RequireRole({
  allowed,
  children,
}: {
  allowed: (permissions: Permissions) => boolean;
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const permissions = usePermissions();
  if (allowed(permissions)) return <>{children}</>;
  return (
    <div className="banner banner-info" role="status">
      {t("roles.noAccess", { role: t(`roles.${permissions.role}`) })}
    </div>
  );
}
